import config from "./config";

const API_BASE = config.BASE_URL;

// Generic API request function
const request = async (url, method = "GET", data = null) => {
  const options = {
    method,
    headers: {
      "Content-Type": "application/json"
    }
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(`${API_BASE}${url}`, options);
  return response.json();
};

// ================= AUTH =================
export const loginApi = (data) => request("/UserLogin", "POST", data);
export const resetPasswordApi = (data) => request("/ResetPassword", "POST", data);
export const changePassword = (data) => request("/ChangePassword", "POST", data);

// ================= COMPANY =================
export const saveCompanyApi = (data) => request("/SaveCompany", "POST", data);
export const deleteCompanyApi = (id) => request(`/DeleteCompany/${id}`, "DELETE");

// ================= PART =================
export const getPartDetailsApi = (comShortCode) => request(`/GetPartDetails?ComShortCode=${encodeURIComponent(comShortCode)}`, "GET");
export const savePartApi = (data) => request("/SavePartItem", "POST", data);
export const editPartApi = (partId, comShortCode) =>
  request(
    `/EditPart?partid=${encodeURIComponent(partId)}&ComShortCode=${encodeURIComponent((comShortCode || "").toLowerCase())}`,
    "GET"
  );
export const deletePartApi = (partId) => request("/UpdateDeactive", "POST", { part_id: partId });

// ================= ADDL TXT =================
export const getAddlTxt2Api = (comShortCode) => request(`/GetAddlTxt2?ComShortCode=${encodeURIComponent(comShortCode)}`, "GET");
export const saveAddlTxtApi = (data) => request("/SaveAddlTxt2", "POST", data);
export const deleteAddlTxtApi = (id) => request(`/DeleteAddlTxt2/${id}`, "DELETE");

// ================= MASTER DATA =================
export const getMasterDataApi = () => request("/GetCompanyAndParts", "GET");

// ================= PRINT LABEL =================
export const savePrintLabelApi = (data) => request("/SavePrintLabel", "POST", data);
export const savePrintLabelNewApi = (data) => request("/SavePrintLabelNew", "POST", data);
export const getLabelPrintApi = (comShortCode, procName) => {
  let url = `/getLabelPrint?ComShortCode=${encodeURIComponent(comShortCode)}`;
  if (procName) {
    url += `&ProcName=${encodeURIComponent(procName)}`;
  }
  return request(url, "GET");
};
export const insertIndividualPrintApi = (data) => request("/InsertIndividualPrint", "POST", data);

export const getReportApi = (fromDate, toDate, comShortCode) => request( `/GetReport?FromDate=${encodeURIComponent
  (fromDate)}&ToDate=${encodeURIComponent(toDate)}&ComShortCode=${encodeURIComponent(comShortCode)}`,"GET" );

// ================= TEMPLATES =================
export const getTemplatesApi = (comShortCode) => request(`/GetTemplates?ComShortCode=${encodeURIComponent(comShortCode)}`, "GET");

// ================= COMPANY BY SHORT CODE =================
export const getCompanyByShortCodeApi = (comShortCode) => request(`/GetCompanyByShortCode?ComShortCode=${encodeURIComponent(comShortCode)}`, "GET");
